
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { FilePlus } from 'lucide-react';

export const ReportsHeader: React.FC = () => {
  return (
    <div className="flex justify-between items-center mb-6">
      <h1 className="text-2xl font-bold">รายงานพัฒนาการนักเรียน</h1>
      <Button asChild variant="default">
        <Link to="/form" className="flex items-center">
          <FilePlus className="mr-2 h-5 w-5" />
          สร้างรายงานใหม่
        </Link>
      </Button>
    </div>
  );
};
